import { render, staticRenderFns } from "./WidgetInstructionsFive.vue?vue&type=template&id=0c4e1654&"
import script from "./WidgetInstructionsFive.vue?vue&type=script&lang=js&"
export * from "./WidgetInstructionsFive.vue?vue&type=script&lang=js&"
import style0 from "./WidgetInstructionsFive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports